module.exports = __webpack_public_path__ + "img/Mint.2846cca0.png";